/*
  ZOOM TISSU tile -> shows the fabric macro IN the hero, instead of opening
  it in a new tab.

  The tile is an <a> to the product's `zoom_assets` file (xm-main-product),
  so with no JS it still opens the image. Only a tile pointing at an
  `xm-zoom-*` theme asset is taken over: a product with no macro falls back
  to its hero at 2000px, and swapping the hero for itself would do nothing.

  It mirrors bindThumbs() in xm-product.js (src swap, srcset dropped,
  aria-current moved) and lives in its own file so the section and that
  script do not have to change for it.
*/
(function () {
  function bind(root) {
    var tile = root.querySelector('a.tpdp-thumb--util[href*="/assets/xm-zoom-"]');
    var hero = root.querySelector('.tpdp-hero img');
    if (!tile || !hero || tile.dataset.xmZoomBound) return;
    tile.dataset.xmZoomBound = 'true';

    var others = root.querySelectorAll('.tpdp-thumb[data-src]');
    var alt = tile.dataset.alt || '';
    var token = 0;

    tile.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      // Chosen state first; the picture swap follows in the next frame and
      // is decoded before it replaces the current one.
      others.forEach(function (b) { b.removeAttribute('aria-current'); });
      tile.setAttribute('aria-current', 'true');
      if (alt) hero.alt = alt;
      var href = tile.href;
      var mine = ++token;
      window.requestAnimationFrame(function () {
        var probe = new Image();
        probe.src = href;
        var swap = function () {
          if (mine !== token) return; // another thumb was chosen meanwhile
          hero.src = href;
          hero.removeAttribute('srcset');
        };
        if (probe.decode) probe.decode().then(swap, swap);
        else swap();
      });
    });

    others.forEach(function (b) {
      b.addEventListener('click', function () { token += 1; tile.removeAttribute('aria-current'); });
    });
  }

  function init() {
    document.querySelectorAll('[id^="xm-tpdp-"]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
